import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${theme.border.outline}`,
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.118rem',
    cursor: 'pointer'
  },

  selectedFolder: {
    marginLeft: '0.5rem',
    marginRight: '0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.textAlt
  },

  menu: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: '1px solid #EAEAEA',
    boxSizing: 'border-box',
    borderRadius: '7px',
    minWidth: '480px',
    width: '480px',
    maxWidth: '480px',
    boxShadow: '0 20px 30px rgba(0, 0, 0, 0.15)',
    padding: '24px',
    background: 'white'
  },

  search: {
    marginBottom: '24px',
    width: '432px',
    height: '32px'
  },

  items: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '2px',

    '& > :not(:last-child)': {
      marginBottom: '2px'
    }
  },

  item: {
    marginLeft: '-10px',
    marginRight: '-10px',
    borderRadius: '4px',
    padding: '10px',
    fontSize: theme.size.base,
    color: '#3C425B',
    cursor: 'pointer',
    transition: 'all 200ms',

    '&:hover': {
      background: '#F0F0F0'
    }
  },

  createItem: {
    display: 'flex',
    alignItems: 'center',
    background: '#F0F0F0',
    fontStyle: 'italic'
  },

  createIcon: {
    marginRight: '8px'
  }
}))

export default useStyles
